// extracted by mini-css-extract-plugin
export default {"mainDivClasses":"videos_mainDivClasses__J94tS"};